import * as React from 'react';

function SvgCheckmarkDone(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { fill: "currentColor", fillRule: "evenodd", d: "M17.469 5.747a.71.71 0 01.068 1l-6.074 6.969a.71.71 0 11-1.07-.932l6.075-6.969a.71.71 0 011-.068zm4.289 0a.71.71 0 01.067 1.001L11.819 18.183a.709.709 0 01-1.025.045l-5.956-5.716a.71.71 0 11.982-1.024l5.42 5.203 9.517-10.877a.71.71 0 011-.066zm-19.55 7.18a.71.71 0 011.003 0l4.288 4.288a.71.71 0 01-1.003 1.003L2.208 13.93a.71.71 0 010-1.003z", clipRule: "evenodd" })));
}

export default SvgCheckmarkDone;
